import React, { useEffect, useState } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import {
  ScoutingReportContainer,
  ScoutingReportMain,
  ScoutingReportImageSection,
  ScoutingReportDetailsSection,
  PlayerCard,
  ReportsHeader,
} from "./ScoutingReports.styles";
import helmetSrc from "../../assets/img/helmetScout.png";
import { ScoutingReportGlobalStyles } from "../ScoutingReport/ScoutingReport.styles";
import GSrc from "../../assets/img/G.png";
import ScoutCard from "../../components/ScoutingReports/ScouteCard.jsx";
import scouteSRC from "../../assets/img/scouteCard.png";
import NFLAnalysisSrc from "../../assets/img/NFLAnalysis.png";
import { MdModeEdit } from "react-icons/md";
import { useDispatch, useSelector } from "react-redux";
import { selectUser } from "../../app/features/user/userSlice";
import { getReportById } from "../../app/features/scoutingReports/reportAction";

const scouteCardData = [
  {
    name: "Lorem ipsum dolor sit amet consectetur. Et tellus eget montes",
    report:
      "Lorem ipsum dolor sit amet consectetur. Habitant mi urna vel integer. Eget sed id massa sed. Cursus enim sit eget eget. Ac non laoreet in in magna platea risus neque blandit.",
    image: helmetSrc,
    date: "Jan 20, 2025",
  },
  {
    name: "Lorem ipsum dolor sit amet consectetur. Et tellus eget montes",
    report:
      "Lorem ipsum dolor sit amet consectetur. Habitant mi urna vel integer. Eget sed id massa sed. Cursus enim sit eget eget. Ac non laoreet in in magna platea risus neque blandit.",
    image: scouteSRC,
    date: "Jan 20, 2025",
  },
  {
    name: "Lorem ipsum dolor sit amet consectetur. Et tellus eget montes",
    report:
      "Lorem ipsum dolor sit amet consectetur. Habitant mi urna vel integer. Eget sed id massa sed. Cursus enim sit eget eget. Ac non laoreet in in magna platea risus neque blandit.",
    image: helmetSrc,
    date: "Jan 20, 2025",
  },
  {
    name: "Lorem ipsum dolor sit amet consectetur. Et tellus eget montes",
    report:
      "Lorem ipsum dolor sit amet consectetur. Habitant mi urna vel integer. Eget sed id massa sed. Cursus enim sit eget eget. Ac non laoreet in in magna platea risus neque blandit.",
    image: scouteSRC,
    date: "Jan 20, 2025",
  },
];
// Mock data - replace with actual API call
const mockPlayerData = {
  name: "Player Name",
  position: "QB",
  school: "Georgia",
  height: "6050",
  weight: "320lbs",
  class: "Senior",
  teamLogo:
    "https://upload.wikimedia.org/wikipedia/commons/5/5c/Georgia_Bulldogs_logo.svg",
  stats: {
    goals: "6050",
    assists: "320lbs",
    minutes: "Senior",
    cups: 45,
  },
  verified: {
    height: true,
    weight: true,
    goals: true,
    assists: true,
  },
};

// Author data - make this dynamic
const authorData = {
  name: "John Doe",
  title: "NFL Draft Lead",
  bio: "Kyle began his career as an independent NFL Draft analyst in 2013, founding NDT Scouting, a service that provided scouting reports and consultations for agencies. After several seasons, he transitioned full-time into the media. In 2018, Kyle became one of the original co-founding members of The Draft Network, where he served as Director of Scouting from 2019 to the spring of 2023. Kyle led a team of scouts during this time, coordinating both college & pro scouting programs. During this period, Kyle also contributed as a writer and analyst for outlets such as USA Today and Athlon Sports. Additionally, he is a prominent figure in TDN/RA Media's Locked On Podcast Network, hosting the Locked On Dolphins podcast and co-hosting the Locked On NFL Scouting podcast. He now serves as the TDN team's NFL Draft lead, where he merges college scouting evaluations with a refined understanding of the NFL and team-building trends for every franchise.",
  image: helmetSrc, // You can replace this with an author photo if available
};

const ScoutingReportDetails = () => {
  const { id } = useParams();
  const { report, reportLoading, reportSuccess, reportError } = useSelector(
    (state) => state.scoutingReports
  );
  const { userToken, userInfo } = useSelector(selectUser);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  useEffect(() => {
    if (userToken?.access) {
      dispatch(getReportById({ token: userToken.access, id }));
    }
  }, [dispatch, userToken, id]);
  // console.log(userInfo, "userInfo");
  // useEffect(() => {
  //   // Simulate API call - replace with actual API call
  //   const fetchPlayerData = async () => {
  //     try {
  //       // TODO: Replace with actual API call
  //       // const response = await axios.get(`${API_ENDPOINT}/players/${id}`);
  //       // setPlayerData(response.data);

  //       // Using mock data for now
  //       setPlayerData(mockPlayerData);
  //       setLoading(false);
  //     } catch (error) {
  //       console.error("Error fetching player data:", error);
  //       setLoading(false);
  //     }
  //   };

  //   fetchPlayerData();
  // }, [id]);

  if (reportLoading) {
    return <div>Loading...</div>;
  }

  if (!report) {
    return <div>Player not found</div>;
  }

  return (
    <div style={{ overflow: "hidden" }}>
      <ScoutingReportGlobalStyles />
      {/* Author Section */}
      <ScoutingReportContainer>
        <ScoutingReportMain>
          {/* Left: Team Logo */}
          <ScoutingReportImageSection>
            <img
              src={helmetSrc}
              alt="Team Logo"
              style={{ width: "100%", height: "100%", objectFit: "cover" }}
            />
          </ScoutingReportImageSection>
          {/* Right: Player Details Card */}
          <ScoutingReportDetailsSection>
            <PlayerCard>
              <div className="player-info">
                <div style={{ display: "flex", gap: "10px" }}>
                  <img
                    src={NFLAnalysisSrc}
                    alt="NFL Analysis"
                    style={{ width: "100px" }}
                  />
                  {userInfo?.id === report?.user_id && <button
                    onClick={() => navigate(`/scouting-reports/edit/${report?.id}`,{state: {singleReport: true}})}
                    style={{
                      border: "1px solid #022142",
                      padding: "5px",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                    }}
                  >
                    <MdModeEdit />
                  </button>}
                </div>
                <div className="player-name">
                  {report?.player_name || "N/A"}
                </div>
                <div className="player-meta">
                  <span>
                    Position: <b>{report?.position || "N/A"}</b>
                  </span>
                  <span>
                    School: <b>{report?.school || "N/A"}</b>
                  </span>
                </div>
                <img src={GSrc} alt="G" style={{ width: "100px" }} />
                <div className="player-physical">
                  <div>
                    <b>Height:</b> {report?.height || "N/A"}{" "}
                    {report?.verified?.height && (
                      <span className="verified">(verified)</span>
                    )}
                  </div>
                  <div>
                    <b>Weight:</b> {report?.weight || "N/A"}{" "}
                    {report?.verified?.weight && (
                      <span className="verified">(verified)</span>
                    )}
                  </div>
                  <div>
                    <b>Class:</b> {report?.class || "N/A"}
                  </div>
                </div>
                <div className="stats-awards">
                  <div className="stats-label">Stats and Awards</div>
                  <div className="stats-list">
                    <div>
                      <b>Goals scored:</b> {report?.goals_scored || "N/A"}{" "}
                      {report?.user_verified && (
                        <span className="verified">(verified)</span>
                      )}
                    </div>
                    <div>
                      <b>Assists:</b> {report?.assists || "N/A"}{" "}
                      {report?.user_verified && (
                        <span className="verified">(verified)</span>
                      )}
                    </div>
                    <div>
                      <b>Minutes played:</b> {report?.minutes || "N/A"}
                    </div>
                    <div>
                      {typeof report?.cups === "number" && report.cups > 0 ? (
                        <>
                          <b>
                            {Array.from({ length: report.cups })
                              .map(() => "🏆")
                              .join("")}
                          </b>{" "}
                          {report.cups} Cup{report.cups > 1 ? "s" : ""}
                        </>
                      ) : (
                        "Cups N/A"
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </PlayerCard>
          </ScoutingReportDetailsSection>
        </ScoutingReportMain>
        {/* Scouting Report Sections */}
      </ScoutingReportContainer>
      <div
        style={{
          background: "transparent",
          margin: "2rem auto",
          maxWidth: "80%",
          display: "flex",
          gap: "2rem",
          overflowX: "hidden",
        }}
      >
        <div className="flex-1" style={{ flex: 1 }}>
          <section style={{ marginBottom: "50px" }}>
            <h2 style={{ color: "#022142" }}>Scouting Report</h2>
            <p style={{ color: "#555555" }}>
              {report?.scouting_report || "N/A"}
            </p>
          </section>
          <section style={{ marginBottom: "2rem" }}>
            <h2 style={{ color: "#022142" }}>Strengths</h2>
            <p style={{ color: "#555555" }}>{report?.strengths || "N/A"}</p>
          </section>
          <section style={{ marginBottom: "2rem" }}>
            <h2 style={{ color: "#022142" }}>Weaknesses</h2>
            <p style={{ color: "#555555" }}>{report?.weaknesses || "N/A"}</p>
          </section>
          <section style={{ marginBottom: "2rem" }}>
            <h2 style={{ color: "#022142" }}>
              Intangibles and Off-Field Red Flag
            </h2>
            <p style={{ color: "#555555" }}>{report?.intangibles || "N/A"}</p>
          </section>
        </div>
        <div className="flex-1" style={{ flex: 1 }}>
          <section style={{ marginBottom: "2rem" }}>
            <h2 style={{ color: "#022142" }}>Ideal Scheme Fit, Role</h2>
            <p style={{ color: "#555555" }}>{report?.ideal_scheme || "N/A"}</p>
          </section>
          <section style={{ marginBottom: "2rem" }}>
            <h2 style={{ color: "#022142" }}>NFL Stylistic Comparison</h2>
            <p style={{ color: "#555555" }}>
              {report?.nfl_comparison || "N/A"}
            </p>
          </section>
          <section style={{ marginBottom: "2rem" }}>
            <h2 style={{ color: "#022142" }}>
              How does he project to fit in with his new team?
            </h2>
            <p style={{ color: "#555555" }}>{report?.team_fit || "N/A"}</p>
          </section>
          <section style={{ marginBottom: "2rem" }}>
            <h2 style={{ color: "#022142" }}>
              Why (Insert prospect name) instead of (comparable prospect 1) or
              (comparable prospect 2)?
            </h2>
            <p style={{ color: "#555555" }}>
              {report?.comparison_reasoning || "N/A"}
            </p>
          </section>
        </div>
      </div>
      <div
        style={{
          display: "flex",
          alignItems: "flex-start",
          background: "transparent",
          borderRadius: "8px",
          padding: "2rem",
          margin: "2rem auto 2rem auto",
          maxWidth: "80%",
          gap: "2rem",
          overflowX: "hidden",
        }}
      >
        <div style={{ flex: "0 0 220px" }}>
          <img
            src={authorData.image}
            alt="Author Helmet"
            style={{
              width: "464px",
              height: "351px",
              objectFit: "cover",
              borderRadius: "8px",
            }}
          />
        </div>
        <div style={{ flex: 1 }}>
          <div style={{ marginBottom: "0.5rem" }}>
            <span
              style={{
                background: "#022142",
                color: "#fff",
                fontSize: "0.75rem",
                padding: "0.2rem 0.7rem",
                borderRadius: "4px",
                fontWeight: 600,
                letterSpacing: "1px",
                marginRight: "0.5rem",
              }}
            >
              Author
            </span>
          </div>
          <div
            style={{ fontSize: "1.5rem", fontWeight: 700, color: "#022142" }}
          >
            {authorData.name}
          </div>
          <div
            style={{
              fontSize: "1rem",
              color: "#555",
              fontWeight: 500,
              marginBottom: "0.7rem",
            }}
          >
            {authorData.title}
          </div>
          <div style={{ color: "#555", fontSize: "0.98rem", lineHeight: 1.6 }}>
            {authorData.bio}
          </div>
        </div>
      </div>
      <div style={{ marginTop: "50px", width: "80%", margin: "auto" }}>
        <ReportsHeader>
          <div className={"blockTitle"}>Other</div>
        </ReportsHeader>
        <div style={{ display: "flex", gap: "2rem" }}>
          {scouteCardData.map((item, index) => (
            <ScoutCard
              key={index}
              name={item.name}
              report={item.report}
              image={item.image}
              date={item.date}
            />
          ))}
        </div>
      </div>
    </div>
  );
};

export default ScoutingReportDetails;
